// AI Generated Component
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { UsersComponent } from './users.component';
import { UsersTableComponent } from './table/table.component';
import { UsersRoutingModule } from './users-routing.module';

// Import shared components and modules
import { LayoutModule, MonEventTriggerModule, MonTableSortModule, TableModule } from '@monsido/angular-shared-components';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ExportModule } from '@client/app/modules/export/export.module';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';
import { MonAvatarComponent } from '@client/app/shared/mon-avatar/mon-avatar.component';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        MonAvatarComponent,
        CommonModule,
        FormsModule,
        UIRouterModule,
        NgbModule,
        UsersRoutingModule,
        LayoutModule,
        MonEventTriggerModule,
        MonTableSortModule,
        TableModule,
        ComponentsModule,
        UpgradePipeModule,
        TranslateModule,
        ExportModule,
        ModalsDirectivesModule,
    ],
    declarations: [UsersComponent, UsersTableComponent],
    exports: [UsersComponent, UsersTableComponent],
})
export class UsersModule {}
